import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import type { GraphCommandEvents } from 'components/Graph/model/GraphCommandEvents';

interface RemoveGraphCommandEventListenerCommand<
  TEventName extends keyof GraphCommandEvents = keyof GraphCommandEvents,
> {
  eventType: TEventName;
  listener: GraphCommandEvents[TEventName];
}

/**
 * Remove event listener for graph command events
 *
 * See addGraphCommandEventListener for explanation how this command is used.
 *
 * @see addGraphCommandEventListener
 */
export const removeGraphCommandEventListener = <
  TEventName extends keyof GraphCommandEvents,
>(
  eventType: TEventName,
  listener: GraphCommandEvents[TEventName],
): [
  GraphCommandFactory<RemoveGraphCommandEventListenerCommand>,
  RemoveGraphCommandEventListenerCommand,
] => [
  (cmdContext) => (command) => {
    cmdContext.eventEmitter.removeListener(command.eventType, command.listener);
  },
  { eventType, listener },
];
